import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

const OPEN_DURATION = 360
const CLOSE_DURATION = 280
const EASING = 'cubic-bezier(0.32, 0.24, 0.15, 1)'

export class UcoastFaqItem extends UcoastEl {
	static htmlSelector = 'ucoast-faq-item'

	private details!: HTMLDetailsElement
	private summary!: HTMLElement
	private content!: HTMLElement
	private animation?: Animation
	private isClosing = false
	private isExpanding = false

	override connectedCallback() {
		super.connectedCallback()
		this.details = q.rs<HTMLDetailsElement>('details', this)
		this.summary = q.rs('summary', this.details)
		this.content = q.rs('.faq__answer', this.details)
		this.summary.addEventListener('click', this.onClick)
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		this.summary?.removeEventListener('click', this.onClick)
	}

	private prefersReducedMotion() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches
	}

	private onClick = (e: MouseEvent) => {
		if (this.prefersReducedMotion()) return
		e.preventDefault()
		this.details.style.overflow = 'hidden'

		if (this.isClosing || !this.details.open) {
			this.open()
		} else if (this.isExpanding || this.details.open) {
			this.shrink()
		}
	}

	private shrink() {
		this.isClosing = true
		this.isExpanding = false

		const startHeight = `${this.details.offsetHeight}px`
		const endHeight = `${this.summary.offsetHeight}px`

		this.animation?.cancel()
		this.animation = this.details.animate(
			{ height: [startHeight, endHeight] },
			{ duration: CLOSE_DURATION, easing: EASING }
		)
		this.content.animate(
			{ opacity: [1, 0] },
			{ duration: Math.round(CLOSE_DURATION * 0.55), easing: 'ease-out', fill: 'forwards' }
		)

		this.animation.onfinish = () => this.onAnimationFinish(false)
		this.animation.oncancel = () => {
			this.isClosing = false
		}
	}

	private open() {
		this.details.style.height = `${this.details.offsetHeight}px`
		this.details.open = true
		window.requestAnimationFrame(() => this.expand())
	}

	private expand() {
		this.isExpanding = true
		this.isClosing = false

		const startHeight = `${this.details.offsetHeight}px`
		const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`

		this.animation?.cancel()
		this.animation = this.details.animate(
			{ height: [startHeight, endHeight] },
			{ duration: OPEN_DURATION, easing: EASING }
		)
		this.content.animate(
			{ opacity: [0, 1] },
			{ duration: OPEN_DURATION - 80, delay: 80, easing: 'ease-out', fill: 'forwards' }
		)

		this.animation.onfinish = () => this.onAnimationFinish(true)
		this.animation.oncancel = () => {
			this.isExpanding = false
		}
	}

	private onAnimationFinish(open: boolean) {
		this.details.open = open
		this.animation = undefined
		this.isClosing = false
		this.isExpanding = false
		this.details.style.height = ''
		this.details.style.overflow = ''
	}
}
